"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasTersifyFn = void 0;
function hasTersifyFn(obj) {
    return typeof obj['tersify'] === 'function';
}
exports.hasTersifyFn = hasTersifyFn;
//# sourceMappingURL=hasTersifyFn.js.map